import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GridComponent, RowSelectEventArgs, RowDeselectEventArgs, SelectionSettingsModel, ToolbarItems, PageSettingsModel } from '@syncfusion/ej2-angular-grids';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { GastoService, MenuFuncionService, MonedaService, AlicuotaIvaService, TipoGastoService, TenantService, EstadoService, ServicioGastoService, ComunidadService, ConsorcioService, ProveedorService } from '../../../../src/app/shared/services';

import { MenuFuncionCodes, Moneda, Gasto, SearchAlicuotaIvaRequest, SearchMonedaRequest, AlicuotaIva, TipoGasto, DialogConfirmRequest, SearchGastoRecurrenteRequest, SaveGastoRequestDto, SearchComunidadRequest, SearchConsorcioRequest, SearchServicioGastoRequest, SearchProveedorRequest, Proveedor, Comunidad, Consorcio, ServicioGasto, TipoGastoComunidadServicioGasto, ComunidadTiposGastos } from '../../../../src/app/shared/model';
import { LocalStorageKeys, TenantFeatureFlags, DialogConfirmResponse } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';

@Component({
  selector: 'app-gastoRecurrente',
  templateUrl: './gastoRecurrente.component.html',
  styles: []
})

export class GastoRecurrenteComponent implements OnInit {

  @ViewChild('deudasGrid')
  public deudasGrid: GridComponent;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isMonedaSearching: boolean = false;
  isAlicuotaIvaSearching: boolean = false;
  isTipoGastoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isServicioGastoSearching: boolean = false;
  isStatisticsSearching: boolean = false;
  isProveedorAutoSearching: boolean = false;
  isComunidadTipoGastoServicioSearching: boolean = false;

  isFileAttaching: boolean = false;
  isGastoDeudaSearching: boolean = false;
  isAttachmentSearching: boolean = false;

  solicitarConfirmacion: boolean = true;

  canEdit: boolean = false;
  canView: boolean = false;
  canAddDeuda: boolean = false;
  canChangeState: boolean = false;

  msgError: string = "";
  item: Gasto;

  deudasPendientesList: any[];

  alicuotaIvaList: AlicuotaIva[];
  tipoGastoComunidadList: TipoGasto[];
  comunidadTipoGastoServicioList: TipoGastoComunidadServicioGasto[];
  comunidadTipoGastoList: ComunidadTiposGastos[];
  comunidadList: Comunidad[];
  consorcioList: Consorcio[];
  servicioGastoList: ServicioGasto[];
  monedaList: Moneda[];
  claseGastoList: any[];
  filteredProveedorList: Proveedor[] = [];

  searchForm: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  totalPorPagar: number = 0;
  public totalesSeleccionados: any[] = [];

  montoTotal: number = 0;

  public deudaSelectionOptions?: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private alicuotaIvaService: AlicuotaIvaService,
    private tipoGastoService: TipoGastoService,
    private servicioGastoService: ServicioGastoService,
    private tenantService: TenantService,
    private proveedorService: ProveedorService,
    private comunidadService: ComunidadService,
    private consorcioService: ConsorcioService,
    private gastoService: GastoService
  ) {
    this.deudaSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.gastoService.clearTempFolder().subscribe(data => {
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    })

    this.menuService.checkMenuPadre(MenuFuncionCodes.GASTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canView = data.Result.some(x => x == MenuFuncionCodes.GASTO_RECURRENTES);
            this.canAddDeuda = data.Result.some(x => x == MenuFuncionCodes.GASTO_ADD);

            if (this.canView && this.canAddDeuda)
              this.loadView();
            else {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.onCancel();
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();

    this.searchGastosRecurrentes();

    this.getClasesGasto();
    this.getComunidades();
    this.getConsorcios();
    this.getServicios();
    this.getProveedoresAutocomplete();
    this.getMonedas();
    this.getAlicuotaIva();
  }

  buildForm() {
    var fechaHoy = new Date();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'FechaGastoDesde': [new Date(fechaHoy.getFullYear(), fechaHoy.getMonth() - 1, 1)],
      'FechaGastoHasta': [fechaHoy],

      'Detalle': [null],
      'Proveedor': [null],
      'ConsorcioId': [cId],
      'ComunidadId': [null],
      'UnidadFuncionalCodigo': [null],
      'TipoGastoId': [null],
      'ServicioGastoId': [null],
      'ClaseGasto': [null],

      'VerSoloRecurrentes': [true],
      // 'VerSoloActivos': [true],
      'gridPage': [1]
    });

    // var filtros = this.sharedFunctions.getReporteFiltros("app-gastoLista");
    // if (filtros != null)
    //   this.searchForm.patchValue(filtros);
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
        this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  checkVerSoloRecurrentes() {
    return (this.searchForm?.get("VerSoloRecurrentes")?.value ?? false);
  }

  isProcessing() {
    return (this.isSearching || this.isSaving);
  }

  getClasesGasto() {
    this.claseGastoList = [
      { Id: 1, Nombre: "Ver Solo de Comunidades" },
      { Id: 2, Nombre: "Ver Solo de Unidades Funcionales" }
    ];
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getConsorcios() {
    if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
     return false;

    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      if (data != null)
        this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getServicios() {
    var r = new SearchServicioGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isServicioGastoSearching = true;

    this.servicioGastoService.search(r).subscribe(data => {
      this.isServicioGastoSearching = false;
      if (data != null)
        this.servicioGastoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isServicioGastoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getProveedoresAutocomplete() {
    this.searchForm.get('Proveedor')?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.filteredProveedorList = [];
          this.isProveedorAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.isProveedorAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.filteredProveedorList = data.result;
        else
          this.filteredProveedorList = [];
        // (this.filteredProveedorList, 'lista proveedor')
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null, null, true, "Nombre", null, null, null, null, true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onAlicuotaIvaSelect() {
    this.calcularMontos();
  }

  calcularMontos() {
    // var importeBase = (this.formGroup.get("ImporteBase")?.value ?? 0);
    // var importePercepciones = (this.formGroup.get("MontoPercepciones")?.value ?? 0) * (this.operacion > 0 ? -1 : 1);

    // var alicuota = this.alicuotaIvaList?.find(f => f.Id == this.formGroup.get("AlicuotaIvaId")?.value);
    // if (alicuota != null && alicuota.Id > 0)
    //   this.montoIva = (importeBase * (alicuota.Porcentaje / 100));
    // else
    //   this.montoIva = 0;

    // this.montoTotal = importeBase + this.montoIva + (importePercepciones * (this.formGroup.get("CantidadCuotas")?.value ?? 1));
    // this.montoCuota = (this.montoTotal * (1 + ((this.formGroup.get('PorcentajeAjusteCuota').value ?? 0) / 100))) / (this.formGroup.get("CantidadCuotas")?.value ?? 1);

    this.calcularTotalPorPagar();
  }

  onTipoGastoComunidadSelect() {
    // var tipoGastoComunidad = this.formGroup.get("TipoGastoComunidad").value;

    // this.comunidadTipoGastoServicioList = null;
    // this.formGroup.get("ServicioGastoId")?.setValue(null);

    // if (tipoGastoComunidad != null && tipoGastoComunidad.Id > 0) {
    //   this.formGroup.get("TipoGastoId")?.setValue(tipoGastoComunidad.TipoGastoId);
    //   this.loadComunidadTipoGastoServicios(tipoGastoComunidad.Id);
    // }
  }

  loadComunidadTipoGastoServicios(tipoGastoId) {
    var r = new SearchServicioGastoRequest(null, null, true, "Nombre", null, null, null, tipoGastoId, true);
    this.isComunidadTipoGastoServicioSearching = true;

    this.servicioGastoService.search(r).subscribe(data => {
      this.isComunidadTipoGastoServicioSearching = false;
      this.comunidadTipoGastoServicioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadTipoGastoServicioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  /*
  getErrorFechaGasto() {
    return this.formGroup.get('FechaGasto')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorTipoGastoId() {
    return this.formGroup.get('TipoGastoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorEstadoId() {
    return this.formGroup.get('EstadoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorDetalle() {
    var v = this.formGroup.get('Detalle');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMonedaId() {
    return this.formGroup.get('Moneda')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorImporteBase() {
    return this.formGroup.get('ImporteBase')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMontoPercepciones() {
    return this.formGroup.get('MontoPercepciones')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErroNroComprobante() {
    var v = this.formGroup.get('NroComprobante');
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorMedioPagoId() {
    return this.formGroup.get('MedioPagoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorAlicuotaIvaId() {
    return this.formGroup.get('AlicuotaIvaId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorCantidadCuotas() {
    var v = this.formGroup.get('CantidadCuotas');
    if (v?.hasError('min'))
      return 'Debe ingresar un valor mayor a 0';
    return '';
  }

  getErrorFechaInicioCuota() {
    var v = this.formGroup.get('FechaInicioCuota');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorDiasRecurrenteCuotas() {
    var v = this.formGroup.get('DiasRecurrenteCuotas');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorPorcentajeAjusteCuota() {
    var v = this.formGroup.get('PorcentajeAjusteCuota');
    if (v?.hasError('min'))
      return 'El porcentaje debe ir entre 0 y 100';
    if (v?.hasError('max'))
      return 'El porcentaje debe ir entre 0 y 100';
    return '';
  }
  */

  searchGastosRecurrentes() {
    var r = new SearchGastoRecurrenteRequest(null, null, true, "FechaGasto", null, null, null, null, null, null, null, null, null, null, null, null, null, this.checkVerSoloRecurrentes(), true);

    if (!this.checkVerSoloRecurrentes()) {
      r = { ...r, ...this.searchForm.value }
    }

    this.isGastoDeudaSearching = true;
    this.gastoService.getGastosRecurrentes(r).subscribe(data => {
      this.isGastoDeudaSearching = false;
      this.deudasPendientesList = data?.result;

      this.calcularTotalPorPagar();
    },
    (err: HttpErrorResponse) => {
      this.isGastoDeudaSearching = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDeudaDataBound(args: any) {
    var seleccionados = this.deudasPendientesList?.filter(f => f.Seleccionado == true);

    // Restaurar la selección de filas
    if (seleccionados != null && seleccionados.length > 0) {
      var pageRows = this.deudasGrid.getRowsObject();
      if (pageRows != null && pageRows.length > 0) {
        var indexes: number[] = [];
        for (var i=0; i<pageRows.length; i++) {
          if (seleccionados.some(f => f.Id == (pageRows[i].data as any).Id))
            indexes.push(pageRows[i].index);
        }

        if (indexes != null && indexes.length > 0)
          this.deudasGrid.selectRows(indexes);
      }
    }
  }

  public onDeudaRowSelect(args: RowSelectEventArgs): void {
    if (args.isHeaderCheckboxClicked) {
      var multiSelection = this.deudasGrid.getRowsObject();
      if (multiSelection != null && multiSelection.length > 0) {
        for (var i=0; i<multiSelection.length; i++)
          this.deudasPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = true;
      }
    }
    else {
      if (args?.data != null && (args?.data as any).Id != null)
        this.deudasPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = true;
    }

    this.calcularTotalPorPagar();
  }

  onDeudaRowDeselected(args: RowDeselectEventArgs ): void {
    //Solo cuando hace click en el checkbox de la grilla deselecciona
    if (args.isHeaderCheckboxClicked) {
      var multiSelection = this.deudasGrid.getRowsObject();
      if (multiSelection != null && multiSelection.length > 0) {
        for (var i=0; i<multiSelection.length; i++)
          this.deudasPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = false;
      }
    }
    else {
      if (args?.data != null  && (args?.data as any).Id != null && args?.target?.className == "e-frame e-icons e-uncheck")
        this.deudasPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = false;
    }

    this.calcularTotalPorPagar();
  }

  onGuardar() {
    if (this.deudasPendientesList == null || this.deudasPendientesList.length == 0) {
      this.sharedFunctions.showMessage("Debe tener al menos un gasto en el listado para continuar con la operación", "Error");
      return false;
    }

    if (this.solicitarConfirmacion) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: new DialogConfirmRequest(
          "Confirmación de Operación",
          "¿Seguro que desea generar los " + (this.deudasPendientesList?.length ?? 0) + " gastos que figuran en el listado?",
          "Sí",
          "No"
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          this.doGuardar();
        }
      });
    }
    else
      this.doGuardar();
  }

  doGuardar() {
    var r: SaveGastoRequestDto[] = [];

    for (var i=0; i<this.deudasPendientesList.length; i++) {

      var p = new SaveGastoRequestDto(
        this.deudasPendientesList[i].Id,
        null, //this.deudasPendientesList[i].TipoGastoId,
        null, //this.deudasPendientesList[i].ServicioGastoId,
        this.deudasPendientesList[i].FechaGasto,
        this.deudasPendientesList[i].FechaVencimiento,
        null, //this.deudasPendientesList[i].FechaVencimiento2,

        this.deudasPendientesList[i].Detalle,
        null, //this.deudasPendientesList[i].Observacion,
        this.deudasPendientesList[i].MonedaId,
        this.deudasPendientesList[i].AlicuotaIvaId,
        this.deudasPendientesList[i].ImporteBase,
        null, //this.deudasPendientesList[i].ImporteBase2,
        true,

        this.deudasPendientesList[i].ConsorcioId,
        this.deudasPendientesList[i].ComunidadId,
        this.deudasPendientesList[i].UnidadFuncionalId,

        false,
        0,

        this.deudasPendientesList[i].Adjuntos,
        []
      );

      r.push(p);
      // console.log('doGuardar request: ', r);
    }

    this.isSaving = true;
    this.gastoService.generarGastosRecurrentes(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  calcularTotalPorPagar() {
    this.totalesSeleccionados = [];

    if (this.deudasPendientesList != null && this.deudasPendientesList.length > 0) {
      for (var i=0; i<this.deudasPendientesList.length; i++) {
        var item = this.deudasPendientesList[i];
        var index = this.totalesSeleccionados.findIndex(v => v.key == item.Moneda);

        if (index == null || index < 0) {
          this.totalesSeleccionados.push({ key: item.Moneda, value: 0 });
          index = this.totalesSeleccionados.length - 1;
        }

        var montoIva = 0
        var alicuota = this.alicuotaIvaList?.find(f => f.Id == item.AlicuotaIvaId);
        if (alicuota != null && alicuota.Id > 0)
          montoIva = (item.ImporteBase * (alicuota.Porcentaje / 100));
        else
          montoIva = 0;

        this.totalesSeleccionados[index].value += parseFloat(item.ImporteBase) + montoIva;
      }
    }
  }

  onDeudaGridFieldChange(gastoId: number, event: any) {
    // console.log("onDeudaGridFieldChange - gastoId: " + gastoId, event);
    if (gastoId != null && gastoId > 0 && this.deudasPendientesList != null) {

      var controlName = event?.target?.name ?? event?.targetElement?.name ?? event?.source?.ngControl?.name;
      var controlValue = event?.value ?? event?.target?.value ?? event?.option?.value;
      // console.log("onDeudaGridFieldChange - controlName: " + controlName + " - controlValue: " + controlValue);

      var index = this.deudasPendientesList?.findIndex(f => f.Id == gastoId);
      if (index >= 0) {
        switch (controlName) {
          case "FechaGasto":
            this.deudasPendientesList[index].FechaGasto = controlValue;
            break;
          case "FechaVencimiento":
            this.deudasPendientesList[index].FechaVencimiento = controlValue;
            break;
          case "Detalle":
            this.deudasPendientesList[index].Detalle = controlValue;
            break;
          // case "TipoGastoId":
          //   this.deudasPendientesList[index].TipoGastoId = controlValue;
          //   break;
          case "MonedaId":
            this.deudasPendientesList[index].MonedaId = controlValue;
            this.deudasPendientesList[index].Moneda = this.monedaList?.find(f => f.Id == controlValue)?.Codigo;

            this.calcularTotalPorPagar();
            break;
          case "AlicuotaIvaId":
            this.deudasPendientesList[index].AlicuotaIvaId = controlValue;
            this.calcularTotalPorPagar();
            break;
          case "ImporteBase":
            this.deudasPendientesList[index].ImporteBase = parseFloat(controlValue);
            this.calcularTotalPorPagar();
            break;
        }

        this.deudasGrid.refresh();
        this.calcularTotalPorPagar();
      }
    }
  }

  onRemove(gastoId: number) {

    if (this.solicitarConfirmacion) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: new DialogConfirmRequest(
          "Confirmación de Operación",
          "¿Seguro que desea quitar el gasto del actual listado de recurrentes?",
          "Sí",
          "No"
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          this.doGastoDelete(gastoId);
        }
      });
    }
    else {
      this.doGastoDelete(gastoId);
    }
  }

  doGastoDelete(gastoId: number) {
    if (gastoId != null && gastoId > 0 && this.deudasPendientesList != null) {
      var index = this.deudasPendientesList?.findIndex(f => f.Id == gastoId);
      if (index >= 0) {
        this.deudasPendientesList.splice(index, 1);
        this.deudasGrid.refresh();

        this.calcularTotalPorPagar();
      }
    }
  }

  onFileAttach(gastoId, event) {

    if (gastoId == null || gastoId <= 0 || this.deudasPendientesList == null || this.deudasPendientesList.length == 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un gasto para continuar", "Error");
      this.deudasGrid.refresh();
      return false;
    }

    const files = event.target.files;

    if (files != null && files.length > 0) {

      var index = this.deudasPendientesList?.findIndex(f => f.Id == gastoId);
      if (index == null || index < 0) {
        this.sharedFunctions.showMessage("No se encontró el gasto seleccionado", "Error");
        this.deudasGrid.refresh();
        return false;
      }

      this.isFileAttaching = true;
      this.deudasPendientesList[index].Adjuntos = [];
      this.gastoService.uploadAttachTemp(files).subscribe(data => {
        this.isFileAttaching = false;
        if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
          for (let i=0; i<data.Result.Archivos.length; i++) {
            if (data.Result.Archivos[i] != null) {
              this.deudasPendientesList[index].Adjuntos.push(data.Result.Archivos[i]);
              this.deudasGrid.refresh();
            }
          }
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isFileAttaching = false;
        this.sharedFunctions.handleError(err, true);
      })

    }
  }

  openAdjuntos(item: any) {
    if (item != null && item.Adjuntos != null && item.Adjuntos.length > 0) {
      for (var i=0; i<item.Adjuntos.length; i++) {
        if (item.Adjuntos[i].UrlDocumento != null && item.Adjuntos[i].UrlDocumento.length > 0)
          window.open(item.Adjuntos[i].UrlDocumento, "_blank");
      }
    }
    else {
      this.sharedFunctions.showMessage("No hay archivos adjuntos para visualizar", "Error");
      this.deudasGrid.refresh();
    }
  }
}
